

















































import { Component, Vue, Prop } from 'vue-property-decorator';

import isMobile from '@/utils/mobile-check';

import { Surface, Picture } from '@/components/atoms';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import { FilledButton } from '@/components/molecules';
import TagBirthday from './DataPresentation/TagBirthday.vue';
import TagSpecialCoin from '@/componentsV2/atoms/TagSpecialCoin/TagSpecialCoin.vue';
import EducationButton from '@/components/atoms/EducationButton/EducationButton.vue';
import { IEducationPlayerProps } from '@/componentsV2/molecules/EducationPlayer/EducationPlayer';
import PlusCircle from '@/components/icons/PlusCircle.vue';

@Component({
  components: {
    Surface,
    Picture,
    Typography,
    FilledButton,
    TagBirthday,
    TagSpecialCoin,
    EducationButton,
    PlusCircle
  }
})
export default class EmptyState extends Vue {
  @Prop() disabled?: boolean;
  @Prop() educationVideo?: IEducationPlayerProps;

  get isMobileDevice() {
    return isMobile();
  }

  get tPrefix() {
    return `offers.emptyState`;
  }

  gotoSpecialCoinCreation() {
    this.$analytics({
      eventCategory: 'Special Coin Offer | Empty state',
      eventAction: 'click',
      eventLabel: 'Clicked on the "Create a Special Coin offer" button'
    });

    this.$router.push('/special-coins-offers/create');
  }
}
